import InviteForm from './InviteForm.vue';

export default InviteForm;



// WEBPACK FOOTER //
// ./src/components/page/invite/form/index.ts